<button [ngClass]="'no-hidden'" *ngIf="show" class="btn btn-primary" (click)="scrollTop()">
    <fa-icon [icon]="icon"></fa-icon> Subir
</button>